// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/authz/v1/authz.proto (package mono.authz.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AdminAddGroupMemberRequest, AdminAddGroupMemberResponse, AdminApplyGroupTemplateRequest, AdminApplyGroupTemplateResponse, AdminApplyRoleTemplateRequest, AdminApplyRoleTemplateResponse, AdminArchiveTemplateRequest, AdminArchiveTemplateResponse, AdminCreateBundleRequest, AdminCreateBundleResponse, AdminCreateDelegationRequest, AdminCreateDelegationResponse, AdminCreateGroupRequest, AdminCreateGroupResponse, AdminCreateRoleAssignmentRequest, AdminCreateRoleAssignmentResponse, AdminCreateScopeNodeRequest, AdminCreateScopeNodeResponse, AdminDeleteBundleRequest, AdminDeleteBundleResponse, AdminDeleteGroupRequest, AdminDeleteGroupResponse, AdminExtendDesigneeRequest, AdminExtendDesigneeResponse, AdminGetScopeTreeRequest, AdminGetScopeTreeResponse, AdminGetTemplateDiffRequest, AdminGetTemplateDiffResponse, AdminListAccessRulesRequest, AdminListAccessRulesResponse, AdminListAssignmentsForGroupRequest, AdminListAssignmentsForGroupResponse, AdminListAssignmentsForScopeNodeRequest, AdminListAssignmentsForScopeNodeResponse, AdminListAssignmentsForUserRequest, AdminListAssignmentsForUserResponse, AdminListBundlesRequest, AdminListBundlesResponse, AdminListDataPacksRequest, AdminListDataPacksResponse, AdminListDelegationsRequest, AdminListDelegationsResponse, AdminListGrantEventsRequest, AdminListGrantEventsResponse, AdminListGroupMembersRequest, AdminListGroupMembersResponse, AdminListGroupsForUserRequest, AdminListGroupsForUserResponse, AdminListGroupsRequest, AdminListGroupsResponse, AdminListGroupTemplatesRequest, AdminListGroupTemplatesResponse, AdminListRoleTemplatesRequest, AdminListRoleTemplatesResponse, AdminListScopeNodesRequest, AdminListScopeNodesResponse, AdminPublishTemplateRequest, AdminPublishTemplateResponse, AdminRemoveGroupMemberRequest, AdminRemoveGroupMemberResponse, AdminRequestBreakGlassRequest, AdminRequestBreakGlassResponse, AdminResetAccessRuleRequest, AdminResetAccessRuleResponse, AdminRevokeDelegationRequest, AdminRevokeDelegationResponse, AdminRevokeRoleAssignmentRequest, AdminRevokeRoleAssignmentResponse, AdminSaveAsTemplateRequest, AdminSaveAsTemplateResponse, AdminUpdateAccessRuleRequest, AdminUpdateAccessRuleResponse, AdminUpdateBundleRequest, AdminUpdateBundleResponse, AdminUpdateGroupRequest, AdminUpdateGroupResponse, AdminUpdateScopeNodeRequest, AdminUpdateScopeNodeResponse, BatchCheckRequest, BatchCheckResponse, CancelAccessRequestRequest, CancelAccessRequestResponse, CheckRequest, CheckResponse, CreatePolicyRequest, CreatePolicyResponse, DecideAccessRequestRequest, DecideAccessRequestResponse, DeletePolicyRequest, DeletePolicyResponse, GetAccessRequestRequest, GetAccessRequestResponse, GetPoliciesRequest, GetPoliciesResponse, ListAccessHistoryRequest, ListAccessHistoryResponse, ListAccessRequestsRequest, ListAccessRequestsResponse, ListAudienceGroupsRequest, ListAudienceGroupsResponse, ListGrantableRolesRequest, ListGrantableRolesResponse, ListScopeNodesRequest, ListScopeNodesResponse, RequestAccessRequest, RequestAccessResponse, ResolveManyActionsRequest, ResolveManyActionsResponse, ResolveManyRequest, ResolveManyResponse, ResolveRequest, ResolveResponse, SearchTenantMembersRequest, SearchTenantMembersResponse, UpdatePolicyRequest, UpdatePolicyResponse, ValidatePolicyRequest, ValidatePolicyResponse } from "./authz_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * AuthzService provides authorization and policy management.
 *
 * @generated from service mono.authz.v1.AuthzService
 */ export const AuthzService = {
    typeName: "mono.authz.v1.AuthzService",
    methods: {
        /**
     * Check performs a single permission check.
     *
     * @generated from rpc mono.authz.v1.AuthzService.Check
     */ check: {
            name: "Check",
            I: CheckRequest,
            O: CheckResponse,
            kind: MethodKind.Unary
        },
        /**
     * BatchCheck performs multiple permission checks in a single request.
     *
     * @generated from rpc mono.authz.v1.AuthzService.BatchCheck
     */ batchCheck: {
            name: "BatchCheck",
            I: BatchCheckRequest,
            O: BatchCheckResponse,
            kind: MethodKind.Unary
        },
        /**
     * Resolve runs the Phase 0.5 viewer-projection resolver and returns
     * the SDS Annex §8 PolicyResult (decision + view_mode + masked_fields
     * + action_blocked + audit-required). UI surfaces (thousand-sunny)
     * and other Go services (via the go-common viewmode library) consume
     * this to project objects per-user.
     *
     * @generated from rpc mono.authz.v1.AuthzService.Resolve
     */ resolve: {
            name: "Resolve",
            I: ResolveRequest,
            O: ResolveResponse,
            kind: MethodKind.Unary
        },
        /**
     * ResolveMany runs the viewer-projection resolver for N (object_type,
     * object_id) targets under one principal + action, amortizing the
     * user-level assignment/bundle/restriction fetches into a single pass.
     * Cross-project rollups (e.g. portfolio dashboards) call this to project
     * every constituent program in one round-trip, then drop/mask rows per the
     * per-target decision so a program the principal can't see never leaks into
     * a total. Returns a per-target ResolvedPolicy keyed by object_id.
     *
     * @generated from rpc mono.authz.v1.AuthzService.ResolveMany
     */ resolveMany: {
            name: "ResolveMany",
            I: ResolveManyRequest,
            O: ResolveManyResponse,
            kind: MethodKind.Unary
        },
        /**
     * ResolveManyActions (SAD-997) is ResolveMany for several actions in one
     * pass: the user's inputs and each target's scope chain are read once,
     * and every (action, target) is still decided on its own. Each action's
     * policies equal ResolveMany's for that action alone. ryugu GetProgram
     * resolves its seven capability verbs this way, not one call each.
     *
     * @generated from rpc mono.authz.v1.AuthzService.ResolveManyActions
     */ resolveManyActions: {
            name: "ResolveManyActions",
            I: ResolveManyActionsRequest,
            O: ResolveManyActionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetPolicies returns all loaded policies.
     *
     * @generated from rpc mono.authz.v1.AuthzService.GetPolicies
     */ getPolicies: {
            name: "GetPolicies",
            I: GetPoliciesRequest,
            O: GetPoliciesResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreatePolicy creates a new authorization policy.
     *
     * @generated from rpc mono.authz.v1.AuthzService.CreatePolicy
     */ createPolicy: {
            name: "CreatePolicy",
            I: CreatePolicyRequest,
            O: CreatePolicyResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdatePolicy updates an existing authorization policy.
     *
     * @generated from rpc mono.authz.v1.AuthzService.UpdatePolicy
     */ updatePolicy: {
            name: "UpdatePolicy",
            I: UpdatePolicyRequest,
            O: UpdatePolicyResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeletePolicy removes an authorization policy.
     *
     * @generated from rpc mono.authz.v1.AuthzService.DeletePolicy
     */ deletePolicy: {
            name: "DeletePolicy",
            I: DeletePolicyRequest,
            O: DeletePolicyResponse,
            kind: MethodKind.Unary
        },
        /**
     * ValidatePolicy validates policy YAML without persisting.
     *
     * @generated from rpc mono.authz.v1.AuthzService.ValidatePolicy
     */ validatePolicy: {
            name: "ValidatePolicy",
            I: ValidatePolicyRequest,
            O: ValidatePolicyResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Phase 0.5 admin RPCs (Component G) --------
     * Enies-lobby is the policy-administration surface. The admin UI
     * (uis/thousand-sunny /admin/access) consumes these; they delegate
     * to pangaea's AuthzGatewayService internally (with the admin
     * secret) so browsers never call pangaea directly.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListBundles
     */ adminListBundles: {
            name: "AdminListBundles",
            I: AdminListBundlesRequest,
            O: AdminListBundlesResponse,
            kind: MethodKind.Unary
        },
        /**
     * The canonical sensitive-data pack catalog (server-owned, read-only) —
     * the vocabulary role editors and the matrix compose visibility from.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListDataPacks
     */ adminListDataPacks: {
            name: "AdminListDataPacks",
            I: AdminListDataPacksRequest,
            O: AdminListDataPacksResponse,
            kind: MethodKind.Unary
        },
        /**
     * Tenant-scoped bundle CRUD — every live bundle is a tenant instance
     * (post-deglobalization). Update/delete only touch rows owned by the
     * caller's tenant; permitted_actions and data_packs are validated against
     * the canonical catalogs server-side; every mutation writes an ops-audit
     * event (round 7). Delete is refused while any un-revoked assignment
     * references the key.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminCreateBundle
     */ adminCreateBundle: {
            name: "AdminCreateBundle",
            I: AdminCreateBundleRequest,
            O: AdminCreateBundleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminUpdateBundle
     */ adminUpdateBundle: {
            name: "AdminUpdateBundle",
            I: AdminUpdateBundleRequest,
            O: AdminUpdateBundleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminDeleteBundle
     */ adminDeleteBundle: {
            name: "AdminDeleteBundle",
            I: AdminDeleteBundleRequest,
            O: AdminDeleteBundleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListAssignmentsForUser
     */ adminListAssignmentsForUser: {
            name: "AdminListAssignmentsForUser",
            I: AdminListAssignmentsForUserRequest,
            O: AdminListAssignmentsForUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminCreateRoleAssignment
     */ adminCreateRoleAssignment: {
            name: "AdminCreateRoleAssignment",
            I: AdminCreateRoleAssignmentRequest,
            O: AdminCreateRoleAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminRevokeRoleAssignment
     */ adminRevokeRoleAssignment: {
            name: "AdminRevokeRoleAssignment",
            I: AdminRevokeRoleAssignmentRequest,
            O: AdminRevokeRoleAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminRequestBreakGlass
     */ adminRequestBreakGlass: {
            name: "AdminRequestBreakGlass",
            I: AdminRequestBreakGlassRequest,
            O: AdminRequestBreakGlassResponse,
            kind: MethodKind.Unary
        },
        /**
     * Delegation (doc 03: temporary delegation) — admin-only nomination
     * (Decision 4, signed off 2026-07-30): mirrors the owner's active grants
     * onto a delegate for a bounded window. Tenant + actor come from the JWT
     * principal, never the request payload — see admin_authz.go:1-12.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminCreateDelegation
     */ adminCreateDelegation: {
            name: "AdminCreateDelegation",
            I: AdminCreateDelegationRequest,
            O: AdminCreateDelegationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListDelegations
     */ adminListDelegations: {
            name: "AdminListDelegations",
            I: AdminListDelegationsRequest,
            O: AdminListDelegationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminRevokeDelegation
     */ adminRevokeDelegation: {
            name: "AdminRevokeDelegation",
            I: AdminRevokeDelegationRequest,
            O: AdminRevokeDelegationResponse,
            kind: MethodKind.Unary
        },
        /**
     * AdminCreateScopeNode registers the scope_node that owns an object so the
     * resolver can narrow assignments to it. A read of an object with no
     * scope_node fails closed to NoView, so this is the prerequisite for
     * granting any scoped role on a fresh object. Delegates to pangaea's
     * CreateScopeNode with the admin secret; tenant is taken from the JWT.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminCreateScopeNode
     */ adminCreateScopeNode: {
            name: "AdminCreateScopeNode",
            I: AdminCreateScopeNodeRequest,
            O: AdminCreateScopeNodeResponse,
            kind: MethodKind.Unary
        },
        /**
     * AdminListScopeNodes lists the tenant's scope nodes, optionally filtered
     * by a case-insensitive display-name/target-id substring. Powers the grant
     * dialog's scope picker — admins find the node that owns an object by the
     * name they know it by instead of pasting a raw scope_node id.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListScopeNodes
     */ adminListScopeNodes: {
            name: "AdminListScopeNodes",
            I: AdminListScopeNodesRequest,
            O: AdminListScopeNodesResponse,
            kind: MethodKind.Unary
        },
        /**
     * AdminUpdateScopeNode renames/re-parents a scope node in the caller's
     * tenant — the "grow into it" lever: create a unit node later and move
     * programs under it. Cycle-guarded; cross-tenant parents are refused.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminUpdateScopeNode
     */ adminUpdateScopeNode: {
            name: "AdminUpdateScopeNode",
            I: AdminUpdateScopeNodeRequest,
            O: AdminUpdateScopeNodeResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Principal groups (polish task 04) --------
     * Groups hold role-bundle assignments like user principals do; members
     * inherit those grants at resolve time. AdminCreateRoleAssignment accepts
     * a group principal via its group_id field.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminCreateGroup
     */ adminCreateGroup: {
            name: "AdminCreateGroup",
            I: AdminCreateGroupRequest,
            O: AdminCreateGroupResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminUpdateGroup
     */ adminUpdateGroup: {
            name: "AdminUpdateGroup",
            I: AdminUpdateGroupRequest,
            O: AdminUpdateGroupResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminDeleteGroup
     */ adminDeleteGroup: {
            name: "AdminDeleteGroup",
            I: AdminDeleteGroupRequest,
            O: AdminDeleteGroupResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListGroups
     */ adminListGroups: {
            name: "AdminListGroups",
            I: AdminListGroupsRequest,
            O: AdminListGroupsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminAddGroupMember
     */ adminAddGroupMember: {
            name: "AdminAddGroupMember",
            I: AdminAddGroupMemberRequest,
            O: AdminAddGroupMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminRemoveGroupMember
     */ adminRemoveGroupMember: {
            name: "AdminRemoveGroupMember",
            I: AdminRemoveGroupMemberRequest,
            O: AdminRemoveGroupMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListGroupMembers
     */ adminListGroupMembers: {
            name: "AdminListGroupMembers",
            I: AdminListGroupMembersRequest,
            O: AdminListGroupMembersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListGroupsForUser
     */ adminListGroupsForUser: {
            name: "AdminListGroupsForUser",
            I: AdminListGroupsForUserRequest,
            O: AdminListGroupsForUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListAssignmentsForGroup
     */ adminListAssignmentsForGroup: {
            name: "AdminListAssignmentsForGroup",
            I: AdminListAssignmentsForGroupRequest,
            O: AdminListAssignmentsForGroupResponse,
            kind: MethodKind.Unary
        },
        /**
     * Grant-ledger read for the admin history surface (authz rebuild Wave 3b,
     * ABAC-014 precondition): every grant/revoke/extend/break-glass/designee
     * event in the caller's tenant, newest first. Self-grants (actor ==
     * subject) are the rows the surface must make loud.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListGrantEvents
     */ adminListGrantEvents: {
            name: "AdminListGrantEvents",
            I: AdminListGrantEventsRequest,
            O: AdminListGrantEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Reverse lookup (authz rebuild Wave 5): every assignment on a scope node
     * — "who has access to Program X?". User + group grants both appear.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListAssignmentsForScopeNode
     */ adminListAssignmentsForScopeNode: {
            name: "AdminListAssignmentsForScopeNode",
            I: AdminListAssignmentsForScopeNodeRequest,
            O: AdminListAssignmentsForScopeNodeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Scope-tree browser (Wave 5): the caller-tenant's scope tree from the
     * tenant root downward, as a flat parent-linked node list (the UI builds
     * the tree client-side from parent_id).
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminGetScopeTree
     */ adminGetScopeTree: {
            name: "AdminGetScopeTree",
            I: AdminGetScopeTreeRequest,
            O: AdminGetScopeTreeResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Templates (finalization WS1) --------
     * Versioned starting points, NEVER grantable. Grants and the resolver only
     * ever see tenant instances (AdminListBundles); templates are a separate
     * gallery. Applying is an explicit snapshot — instances never auto-update
     * when a new template version publishes.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListRoleTemplates
     */ adminListRoleTemplates: {
            name: "AdminListRoleTemplates",
            I: AdminListRoleTemplatesRequest,
            O: AdminListRoleTemplatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminListGroupTemplates
     */ adminListGroupTemplates: {
            name: "AdminListGroupTemplates",
            I: AdminListGroupTemplatesRequest,
            O: AdminListGroupTemplatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Verb/pack/view-mode delta between two versions of a family — powers the
     * "new version available" diff view before an admin chooses to re-apply.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminGetTemplateDiff
     */ adminGetTemplateDiff: {
            name: "AdminGetTemplateDiff",
            I: AdminGetTemplateDiffRequest,
            O: AdminGetTemplateDiffResponse,
            kind: MethodKind.Unary
        },
        /**
     * Copies ONE published template version into a tenant role instance
     * (idempotent — an existing instance for the key is returned untouched).
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminApplyRoleTemplate
     */ adminApplyRoleTemplate: {
            name: "AdminApplyRoleTemplate",
            I: AdminApplyRoleTemplateRequest,
            O: AdminApplyRoleTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * One transaction: materialize the pinned role instances, create the group,
     * create group-targeted grants at the REQUIRED explicit scope — and add
     * ZERO members. People get access only when someone is added to the group.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminApplyGroupTemplate
     */ adminApplyGroupTemplate: {
            name: "AdminApplyGroupTemplate",
            I: AdminApplyGroupTemplateRequest,
            O: AdminApplyGroupTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * Snapshots a tenant role instance into a tenant-private template draft
     * (publish it to make it appliable). Built-in platform templates stay
     * ops-managed; this is the tenant's own reuse/versioning lever.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminSaveAsTemplate
     */ adminSaveAsTemplate: {
            name: "AdminSaveAsTemplate",
            I: AdminSaveAsTemplateRequest,
            O: AdminSaveAsTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * Status transitions for the caller-tenant's OWN templates (draft →
     * published → archived; published rows are immutable — editing = drafting
     * the next version). Platform templates are refused here.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminPublishTemplate
     */ adminPublishTemplate: {
            name: "AdminPublishTemplate",
            I: AdminPublishTemplateRequest,
            O: AdminPublishTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminArchiveTemplate
     */ adminArchiveTemplate: {
            name: "AdminArchiveTemplate",
            I: AdminArchiveTemplateRequest,
            O: AdminArchiveTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Access requests (finalization WS4) --------
     * The "I can't see this, let me ask" loop. RequestAccess/Cancel are open to
     * ANY authenticated tenant member (their own requests only); List/Get/
     * Decide are reviewer-gated — an active access_grantors member, or
     * admin/internal while grantors are unconfigured. A requester never sees
     * reviewer identities, and an unknown target returns the same not-found the
     * object itself would (no existence leak).
     *
     * @generated from rpc mono.authz.v1.AuthzService.RequestAccess
     */ requestAccess: {
            name: "RequestAccess",
            I: RequestAccessRequest,
            O: RequestAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.CancelAccessRequest
     */ cancelAccessRequest: {
            name: "CancelAccessRequest",
            I: CancelAccessRequestRequest,
            O: CancelAccessRequestResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.ListAccessRequests
     */ listAccessRequests: {
            name: "ListAccessRequests",
            I: ListAccessRequestsRequest,
            O: ListAccessRequestsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.GetAccessRequest
     */ getAccessRequest: {
            name: "GetAccessRequest",
            I: GetAccessRequestRequest,
            O: GetAccessRequestResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.DecideAccessRequest
     */ decideAccessRequest: {
            name: "DecideAccessRequest",
            I: DecideAccessRequestRequest,
            O: DecideAccessRequestResponse,
            kind: MethodKind.Unary
        },
        /**
     * Member-facing scope-node typeahead (D12): the self-service delegation
     * dialog needs to search scope nodes by name to pick a target, but
     * AdminListScopeNodes is admin-only — a plain owner filing their own
     * delegation request got a 403 and could never populate the picker. Same
     * query/limit shape as AdminListScopeNodes, gated to any authenticated
     * tenant member instead of admin/internal (mirrors ListGrantableRoles's
     * reviewer-gated wrapper around the admin-only role-bundle list). Its own
     * request/response/node messages — not AdminListScopeNodes's — since the
     * projected node is a strict subset of AdminScopeNode's fields (no
     * parent_id, inherits_from_parent, or sensitivity: those are
     * admin-console-only and must be structurally impossible to leak here).
     *
     * @generated from rpc mono.authz.v1.AuthzService.ListScopeNodes
     */ listScopeNodes: {
            name: "ListScopeNodes",
            I: ListScopeNodesRequest,
            O: ListScopeNodesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Named release audiences: only the authenticated caller's existing groups.
     * No group keys, descriptions, member lists or administrative metadata.
     *
     * @generated from rpc mono.authz.v1.AuthzService.ListAudienceGroups
     */ listAudienceGroups: {
            name: "ListAudienceGroups",
            I: ListAudienceGroupsRequest,
            O: ListAudienceGroupsResponse,
            kind: MethodKind.Unary
        },
        /**
     * SearchTenantMembers is the member-facing delegate-picker typeahead
     * (SAD-112 item b): the self-service "Delegate my access" dialog made a
     * member type the delegate's raw 15+ character user id — this lets them
     * find the delegate by name instead. Deliberately NOT a reuse or widening
     * of mariejois's UserManagementService (ResolveUserNames included): that
     * surface stays behind NewAdminAuthInterceptor, full stop. The exposure
     * accepted here is precise and no wider: any tenant member may find any
     * tenant member's DISPLAY NAME by searching. Nothing else rides along — no
     * email, no role, no scope, no tenant id, no counts, ever on the wire.
     * Same narrow-projection discipline as ListScopeNodes/ScopeNodeSummary:
     * TenantMemberSummary is its own dedicated message, not a slice of an
     * admin-shaped User.
     *
     * @generated from rpc mono.authz.v1.AuthzService.SearchTenantMembers
     */ searchTenantMembers: {
            name: "SearchTenantMembers",
            I: SearchTenantMembersRequest,
            O: SearchTenantMembersResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Delegation (finalization WS5) --------
     * Extends a live designee grant's end date — grantor-gated like every
     * grant-shaped action; one "extended" event, the grant id survives.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminExtendDesignee
     */ adminExtendDesignee: {
            name: "AdminExtendDesignee",
            I: AdminExtendDesigneeRequest,
            O: AdminExtendDesigneeResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Access history (finalization WS8) --------
     * The grant ledger + access-request lifecycle, readable by exactly three
     * shapes of caller: a role carrying the access_audit:read capability, an
     * active access_grantors member, or admin/internal. NON-admin RPC — the
     * capability is grantable to compliance roles who hold no delivery
     * visibility at all (GetProgram stays NoView for them).
     *
     * @generated from rpc mono.authz.v1.AuthzService.ListAccessHistory
     */ listAccessHistory: {
            name: "ListAccessHistory",
            I: ListAccessHistoryRequest,
            O: ListAccessHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Reviewer-facing role vocabulary (round 7): approving an access request
     * needs the tenant's role names, but AdminListBundles is admin-only —
     * non-admin designated grantors could Decide on the backend yet the UI
     * could not load the picker. Gated on the same reviewer check as Decide.
     *
     * @generated from rpc mono.authz.v1.AuthzService.ListGrantableRoles
     */ listGrantableRoles: {
            name: "ListGrantableRoles",
            I: ListGrantableRolesRequest,
            O: ListGrantableRolesResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Access rules (FND-25, SAD-1241) --------
     * Admin › Access rules: the catalogue with each rule's effective value
     * for the caller's tenant. Admin-gated like AdminUpdateBundle; the tenant
     * comes from the gateway principal. Hard denies are read-only labels and
     * no request field can change them.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminListAccessRules
     */ adminListAccessRules: {
            name: "AdminListAccessRules",
            I: AdminListAccessRulesRequest,
            O: AdminListAccessRulesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.authz.v1.AuthzService.AdminUpdateAccessRule
     */ adminUpdateAccessRule: {
            name: "AdminUpdateAccessRule",
            I: AdminUpdateAccessRuleRequest,
            O: AdminUpdateAccessRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * AdminResetAccessRule restores the catalogue default.
     *
     * @generated from rpc mono.authz.v1.AuthzService.AdminResetAccessRule
     */ adminResetAccessRule: {
            name: "AdminResetAccessRule",
            I: AdminResetAccessRuleRequest,
            O: AdminResetAccessRuleResponse,
            kind: MethodKind.Unary
        }
    }
};
